import { gql } from "@apollo/client";

export const CREATE_COMPANY_MUTATION = gql`
  mutation CompanySignup($input: SignupInput!) {
    signup(input: $input) {
      accessToken
    }
  }
`

export const CREATE_COMPANY_ONLY_MUTATION = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      id
      name
      email
      subdomain
      schemaName
    }
  }
`

export const CREATE_COMPANY_OWNER_MUTATION = gql`
  mutation CreateCompanyOwner($input: CreateCompanyOwnerInput!) {
    createCompanyOwner(input: $input) {
      id
      email
      firstName
      lastName
      role
    }
  }
`

export const COPY_COMPANY_MUTATION = gql`
  mutation CopyCompany($input: CopyCompanyInput!) {
    copyCompany(input: $input) {
      company {
        id
        name
        subdomain
        schemaName
      }
      owner {
        id
        email
        firstName
        lastName
      }
    }
  }
`

export const CREATE_PARTNER_MUTATION = gql`
  mutation PartnerSignup($input: PartnerSignupInput!) {
    partnerSignup(input: $input) {
      accessToken
    }
  }
`;

export const UPDATE_COMPANY_MUTATION = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
     id
    name
    email
    address
    city
    state
    country
    zip
    phoneNumber
    countryCode
    aiEnabled
    }
  }
`;

export const DELETE_COMPANY_MUTATION = gql`
  mutation DeleteCompany($id: ID!) {
    deleteCompany(id: $id)
  }
`;

export const RUN_VALIDATION_COVERAGE_FOR_COMPANY_MUTATION = gql`
  mutation RunValidationCoverageForCompany($input: RunValidationCoverageForCompanyInput!) {
    runValidationCoverageForCompany(input: $input) {
      success
      message
      totalAssets
      processed
      failed
    }
  }
`;

export const UPDATE_COMPANY_USER_MUTATION = gql`
mutation UpdateCompanyUser($input: UpdateCompanyUserInput!) {
updateCompanyUser(input: $input) {
    id
    email
    firstName
    role
    lastName
    phoneNumber
    countryCode
   
}
}
`;

export const DELETE_COMPANY_USER_MUTATION = gql`
  mutation DeleteCompanyUser($userId: ID!) {
    deleteCompanyUser(userId: $userId)
  }
`;
